const state = {
  checklist_template_id: undefined,
  data: {},
  debtor_id: undefined,
  debtor_type: undefined,
  due_date: '',
  footer: '',
  header: '',
  hidden: false,
  id: undefined,
  priority: 'default',
  sort: undefined,
  task_list_id: undefined,
  task_list_template_section_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
